import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet, Router } from '@angular/router';

@Component({
  selector: 'app-layout-page',
  imports: [CommonModule, RouterOutlet],
  templateUrl: './layout-page.html',
  styleUrl: './layout-page.css'
})
export class LayoutPage {
  sidebarOpen = true;
  routerUrl = '';
  constructor(private router: Router) {
    // get the current route
    this.routerUrl = this.router.url.split('/').pop() ?? '';
  }
  navigationItems = [
    {
      category: 'Dashboard',
      icon: 'pi pi-home',
      route: 'dashboard'
    },
    {
      category: 'Profile',
      icon: 'pi pi-user',
      route: 'profile'
    },
    {
      category: 'Subscriptions',
      icon: 'pi pi-credit-card',
      route: 'subscriptions'
    },
    {
      category: 'Users',
      icon: 'pi pi-users',
      route: 'users'
    },
    {
      category: 'Sessions',
      icon: 'pi pi-desktop',
      route: 'sessions'
    },
    {
      category: 'Organization',
      icon: 'pi pi-building',
      route: 'account-info'
    }

  ];

  toggleSidebar() {
    this.sidebarOpen = !this.sidebarOpen;
  }

  navigateToPage(route: string) {
    // Map category names to route paths
    const routeMap: { [key: string]: string } = {
      'dashboard': 'dashboard',
      'profile': 'profile',
      'account-info': 'account-info',
      'subscriptions': 'subscriptions',
      'users': 'users',
      'sessions': 'sessions',
      'organization': 'organization'
    };
    const routePath = routeMap[route] || route;
    this.routerUrl = routePath;
    this.router.navigate([`/app/${routePath}`]);
  }
}
